import React from 'react';
import { Heart } from 'lucide-react';

/** Corazón para marcar o desmarcar una trivia como favorita. */
export const FavoriteButton: React.FC<{
  active: boolean;
  title: string;
  onToggle: () => void;
}> = ({ active, title, onToggle }) => (
  <button
    onClick={onToggle}
    aria-pressed={active}
    aria-label={active ? `Quitar ${title} de favoritas` : `Añadir ${title} a favoritas`}
    title={active ? 'Quitar de favoritas' : 'Añadir a favoritas'}
    className={`p-1.5 -m-1.5 rounded-lg shrink-0 transition-colors ${
      active ? 'text-danger-400 hover:text-danger-500' : 'text-ink-500 hover:text-danger-400'
    }`}
  >
    <Heart className="w-5 h-5" fill={active ? 'currentColor' : 'none'} />
  </button>
);
